import type { EventCategory } from "@/types/content";

export const categories: EventCategory[] = [
  {
    slug: "celeb",
    name: "娱乐圈",
    icon: "ri-star-smile-line",
    desc: "合作、换角、合约与舆论场里的明星动态梳理",
  },
  {
    slug: "live",
    name: "直播电商",
    icon: "ri-live-line",
    desc: "主播、选品、价格与售后纠纷的完整链路",
  },
  {
    slug: "variety",
    name: "综艺",
    icon: "ri-tv-2-line",
    desc: "剪辑、赛制与嘉宾关系引发的讨论复盘",
  },
  {
    slug: "music",
    name: "音乐演出",
    icon: "ri-music-2-line",
    desc: "巡演、音乐节与票务争议的时间线拆解",
  },
  {
    slug: "drama",
    name: "短剧影视",
    icon: "ri-film-line",
    desc: "剧集、短剧的创作争议与版权讨论",
  },
  {
    slug: "brand",
    name: "品牌商业",
    icon: "ri-shopping-bag-3-line",
    desc: "联名、发售与营销翻车的前因后果",
  },
  {
    slug: "idol",
    name: "选秀竞技",
    icon: "ri-trophy-line",
    desc: "票数、赛制与数据质疑的来龙去脉",
  },
];